<template>
  <div>
    <div class="jumbotron">
      <div class="mask"></div>
      <b-row class="mx-auto" style="max-width: 1460px">
        <HomeText></HomeText>
        <b-col sm="1"> </b-col>
        <b-col sm="6">
          <b-row class="">
            <HomeOrg :userType="userType"></HomeOrg>
            <HomeTra :userType="userType"></HomeTra>
          </b-row>
          <div class="text-right mt-5">
            <router-link to="/compliance" class="text-white">compliance 11</router-link>
          </div>
        </b-col>
      </b-row>
    </div>
    <HomeSteps></HomeSteps>
  </div>
</template>

<script>
import util from "@/mixing/util";
import HomeOrg from "@/components/HomeOrg";
import HomeTra from "@/components/HomeTra";
import HomeText from "@/components/HomeText";
import HomeSteps from "@/components/HomeSteps";
import UserService from "@/services/user.service";

export default {
  components: { HomeOrg, HomeTra, HomeText, HomeSteps },
  mixins: [util],
  data() {
    return {
      userType: this.$route.params.userType,
      userId: this.$route.params.userId,
      user: [],
      status: [],
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  created() {
    if (this.loggedIn) {
      if (this.userType == "translator") {
        let root = this;
        UserService.whoAmI()
          .then(function (response) {
            let user = response.data;
            root.$router.push("/translators/edit/" + user.id);
          })
          .catch((error) => {
            console.log("Whoami: error");
            console.log(error);
            root.$store.dispatch("auth/logout");
            root.$router.push("/login");
          });
      } else {
        this.$router.push("/users/profile");
      }
    }
  },
  watch: {
    "$route.params": {
      handler(n) {
        this.userType = n.userType;
        //this.fetchData(n.userType);
      },
    },
  },
};
</script>
<style scoped>
.jumbotron {
  background-image: url("/img/bg-home.png");
}
.mask {
  position: absolute;
  background-color: #463a21;
  opacity: 0.4;
  width: 100%;
  height: 100%;
}
</style>
